// @flow
import * as React from 'react';
import Radium from 'radium';
import { compose, withState } from 'recompose';

import {
  Card,
  CardHeader,
  CardBlock,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';

import IconText from 'components/IconText';
import TextEditModal from 'components/TextEditModal';

import TimelineEntry from './TimelineEntry';
import type { TimelineEntry as TimelineEntryType } from './TimelineEntry';

type Props = {
  entries: Array<TimelineEntryType>,
  editable: boolean,
  onComment: (comment: string) => mixed,
  onReloadData: () => mixed,
  onCommentEdited: (index: number, newValue: string) => void,

  // recompose
  comment: string,
  onCommentChange: (comment: string) => void,
  editIndex: ?number,
  onEditIndexChange: (editIndex: ?number) => void,
};

class Timeline extends React.Component<Props> {
  _onSubmitComment = async () => {
    const { comment, onComment, onCommentChange, onReloadData } = this.props;
    if (!comment) {
      return;
    }
    await onComment(comment);
    await onReloadData();
    onCommentChange('');
  };

  render() {
    const {
      editable,
      entries,
      comment,
      onCommentChange,
      onCommentEdited,
      editIndex,
      onEditIndexChange,
    } = this.props;
    const likesCount = entries.filter(e => e.type === 'like').length;
    const commentsCount = entries.filter(e => e.type === 'comment').length;
    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>
          <strong>Ereignisverlauf</strong>
          <div>
            <IconText icon="icon-heart" color="success" text={likesCount} />
            <IconText icon="icon-bubble" color="primary" text={commentsCount} />
          </div>
        </CardHeader>
        <CardBlock>
          {entries.map((entry, index) => (
            <TimelineEntry
              key={`${+entry.createdAt}`}
              onEditClick={() =>
                entry.type === 'comment' && onEditIndexChange(index)
              }
              {...entry}
            />
          ))}
        </CardBlock>
        {editable && (
          <CardBlock>
            <FormGroup>
              <Label>Kommentar hinzufügen</Label>
              <Input
                type="textarea"
                placeholder="Ein sinnvoller Kommentar ..."
                value={comment}
                onChange={event => onCommentChange(event.target.value)}
              />
            </FormGroup>
            <Button
              color="primary"
              disabled={!comment}
              onClick={this._onSubmitComment}
            >
              Kommentieren
            </Button>
          </CardBlock>
        )}
        {editIndex !== null && (
          <TextEditModal
            title="Kommentar bearbeiten"
            inputType="textarea"
            initialValue={entries[editIndex].text}
            onCancel={() => onEditIndexChange(null)}
            onSubmit={value => {
              onCommentEdited(entries[editIndex].commentIndex, value);
              onEditIndexChange(null);
            }}
          />
        )}
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

const TimelineContainer = compose(
  Radium,
  withState('comment', 'onCommentChange', ''),
  withState('editIndex', 'onEditIndexChange', null)
)(Timeline);

export default TimelineContainer;



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.js